import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCaseLogs,clearLogs } from "../../store/features/caseLogsSlice";
import ShipmentInfo from "../../components/Document/ShipmentTable";
import { fetchDocumentsByThreadId } from "../../store/features/documentSlice";
import { useParams,Link } from "react-router-dom";
import { fetchShipmentHistory } from "../../store/features/caseLogsSlice";



const RegistrationView = ({ threadId }) => {
  const dispatch = useDispatch();
  // Access Redux states for shipments and case logs
  const { shipments, status: shipmentStatus } = useSelector((state) => state.shipments);
  const { logs, status: caseLogStatus, error: caseLogError } = useSelector((state) => state.caseLogs);
  // Get shipment details and AI summary
  const shipment = shipments.find((shipment) => shipment.thread_id === threadId);
  // Destructure caseData only if it exists
  const { thread_id, case_number, documents, emailBodies } = shipment;
  console.log("documents",documents)
  // Get the last document
  const lastDocument = documents.reduce((maxDoc, currentDoc) => {
    // Check if mandatory_info or MandatoryInfo is not an empty object
    const hasMandatoryInfo =
      (currentDoc.content.mandatory_info && Object.keys(currentDoc.content.mandatory_info).length > 0) ||
      (currentDoc.content.MandatoryInfo && Object.keys(currentDoc.content.MandatoryInfo).length > 0);
  
    // Only consider documents with non-empty mandatory_info or MandatoryInfo
    if (hasMandatoryInfo) {
      return currentDoc.id < maxDoc.id ? currentDoc : maxDoc;
    }
    return maxDoc; // Keep the current maxDoc if the condition is not met
  }, documents[0]);
  const documentId = lastDocument?.id
  // Safely access mandatoryInfo with fallbacks
  const MandatoryTemplate = lastDocument.content?.mandatory_info || lastDocument.content?.MandatoryInfo || {};
  

  useEffect(() => {
    dispatch(clearLogs()); // Clear existing logs
    }, [dispatch, threadId]);

  // Fetch data if not already loaded
    useEffect(() => {
      const fetchData = async () => {
        if (!shipment || !logs) {
          await dispatch(fetchCaseLogs(case_number));
          await dispatch(fetchShipmentHistory(case_number));
        }
      };
    
      fetchData(); // Call the async function inside useEffect
    }, [dispatch, case_number]);

  // Unified loading state
  if (shipmentStatus === "loading" || caseLogStatus === "loading") {
    return <div>Loading case information...</div>;
  }

  // Unified error handling
  if (shipmentStatus === "failed" || caseLogStatus === "failed") {
    return <div>{caseLogError || "Failed to load case information."}</div>;
  }


  return (
    <div>
      <ShipmentInfo dataTemplate={MandatoryTemplate} threadId={threadId} documentId={documentId} />
    </div>

  );
};

export default RegistrationView;


